import React from 'react'
import {
  ListItem, ListItemIcon, ListItemText, Typography,
} from '@mui/material'
import { CurrentBillingIcon } from 'icons'
import classNames from 'classnames'
import { withStyles } from 'tss-react/mui'
import getDate from '@app/helpers/myEnergy/getDate'
import { IBillingPeriodStat } from '@app/@types/myEnergy'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import styles from './CurrentBillingPeriod.style'

interface Props {
  classes: Record<string, string>,
  billingPeriod: IBillingPeriodStat,
  isMobile: boolean,
}

class CurrentBillingPeriod extends React.PureComponent<Props> {
  render() {
    const {
      classes,
      billingPeriod,
      isMobile,
    } = this.props
    const periodFrom = getDate(billingPeriod.from, 'short')
    const periodTo = getDate(billingPeriod.to, 'short')
    const cost = billingPeriod.billing
    return (
      <ListItem className={classes.listItem}>
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classNames(
            classes.title,
            !isMobile && classes.titleDesktop,
          )}
          >
            {I18n.t('my_energy.current_billint_period')}
          </Typography>
        </Wrapper>
        <Wrapper className={classes.infoWrapper}>
          <ListItemIcon className={classNames(
            classes.iconWrapper,
            !isMobile && classes.iconWrapperDesktop,
          )}
          >
            <CurrentBillingIcon className={classNames(
              classes.icon,
              !isMobile && classes.iconDesktop,
            )}
            />
          </ListItemIcon>
          <ListItemText
            className={classes.info}
            primary={(
              <>
                <Typography
                  component="span"
                  className={classes.infoTime}
                  color="textPrimary"
                >
                  {periodFrom === ''
                    ? <Typography>{I18n.t('my_energy.period_not_set')}</Typography>
                    : `${periodFrom} - ${periodTo}`}
                </Typography>
              </>
            )}
            secondary={(
              <>
                <Typography
                  component="span"
                  className={classNames(
                    classes.infoNumbers,
                    !isMobile && classes.infoNumbersDesktop,
                  )}
                  color="textPrimary"
                >
                  {periodFrom === ''
                    ? `${I18n.t('my_energy.for_current_day')}: ${I18n.t('my_energy.not_available')} $`
                    : `${I18n.t('my_energy.for_current_day')}: ${cost} $`}
                </Typography>
              </>
            )}
          />
        </Wrapper>
      </ListItem>
    )
  }
}

export default withStyles(CurrentBillingPeriod, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
